export default {
  svgData: [
    {
      id: "slide1tv1",
      name: "TV",
      label: "slide1tv1"
    },
    {
      id: "slide1easel1",
      name: "Easel",
      assets: [""],
      label: "slide1easel1"
    },
    {
      id: "slide1display1",
      name: "Display 1",
      assets: [
        "https://cdn.scoutfeedback.com/gdot-workshop/cvl/welcome/project-handout-1.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/cvl/welcome/project-handout-2.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/cvl/welcome/project-handout-3.jpg"
      ],
      label: "slide1display1"
    },
    {
      id: "slide1display2",
      name: "Display 2",
      assets: [
        "https://cdn.scoutfeedback.com/gdot-workshop/cvl/welcome/cvl-fact-sheet.jpg"
      ],
      label: "slide1display2"
    },
    {
      id: "slide1display3",
      name: "Display 3",
      assets: [
        "https://cdn.scoutfeedback.com/gdot-workshop/cvl/welcome/faq-1.jpg",
        "https://cdn.scoutfeedback.com/gdot-workshop/cvl/welcome/faq-2.jpg"
      ],
      label: "slide1display3"
    },
    {
      id: "slide1avatar1"
    }
  ],
  slideTitle: "Welcome",
  aboutText: `
    <p class="text-justify help">
    This virtual meeting room showcases the project concept and information about the project that you might 
    find at a Georgia DOT public meeting. Here you can view different stations or spaces that include handouts, 
    environmental documents, displays, proposed project concept and detours, visualization of the project, and 
    the opportunity to submit public comment. 
    </p>
    <p class="text-justify help">
    The Welcome station includes a <b><u>Welcome Video</u></b> from Georgia DOT staff, and documents on the table 
    include the <b><u>Information Handout</b></u>, <b><u>Fact Sheet</b></u>, and <b><u>FAQ</b></u>. The easel to 
    the right is a <b><u>Project Overview Display</b></u> that includes the Project Map, Project Schedule, 
    Need and Purpose/Project Benefits, and a map of the other projects that are part of the Major Mobility 
    Investment Program (MMIP). 
    </p>
    <p class="text-justify help">
    If you have any questions, please feel free to contact us. 
    </p>
    <p class="text-justify help">
    Email: <a href="mailto:75CVL@dot.ga.gov">75CVL@dot.ga.gov</a>    
    </p>
    <p class="text-justify help">
    Phone: 678-528-7275
    </p>
  `,
  helpText: `
    <p class="text-justify help">
    Thank you for joining our interactive I-75 Commercial Vehicle Lanes project (P.I. No. 0014203) 
    virtual meeting room hosted by the Georgia Department of Transportation (Georgia DOT). The Department 
    has placed updated project information on an online platform in compliance with social distancing guidelines 
    to avoid large gatherings. The online platform and interactive virtual meeting room houses the same project 
    information that you would find at an in-person Public Information Open House (PIOH) for the project. 
    </p>
    <p class="text-justify help">
    Before you enter each station or space of the virtual meeting room, you will receive a pop-up message 
    detailing what resources and specific information are available to you. <b>We encourage you to click on 
    the virtual staff members and assets that are labeled to learn more about the project. Click the 
    following button <i class="mdi mdi-account-question" style="font-size:2em;"></i> to learn about the specific 
    station or the <i class="mdi mdi-information-outline" style="font-size:2em;"></i>
    to see this message again after you close it out.</b> To navigate to a new station or space, click the left or 
    right arrow or select your station of choice from the sidebar on the right.
    </p>
    <p class="text-justify help">
    Now, in this first station, we recommend the following actions to help you learn more about the proposed I-75 
    Commercial Vehicle Lanes project:
    </p>
    <ul class="text-justify help">
      <li>      
      Watch the <b><u>Welcome Video</u></b> to become more familiar with our interactive, virtual meeting room. 
      </li>
      <br>
      <li>
      Click the documents on the table to review the project <b><u>Handout</u></b>, <b><u>Fact Sheet</u></b>, and <b><u>FAQ</u></b>. 
      </li>
      <br>
      <li>
      Click the easel to the right to view the <b><u>Project Map</u></b>, <b><u>Need and Purpose/Project Benefits</u></b>, \
      <b><u>Project Schedule</u></b>, and a map of the other <b><u>Major Mobility Investment Program (MMIP)</u></b> projects.
      </li>
    </ul>
    <br>
    <p class="text-justify help">
    Once your tour of the welcome space is complete, we invite you to visit the next station by clicking on the right arrow or selecting your station of choice from the sidebar on the right. 
    </p>
     `
};
